"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ANIMATION_DURATION = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _AppCordova = _interopRequireDefault(require("../../../../targets/cord_sanofi/AppCordova.js"));

var _AlertHelper = require("../../../helpers/AlertHelper");

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _DrupalTilesStrings = require("./DrupalTilesStrings");

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _NuggetFront = _interopRequireDefault(require("./NuggetFront"));

var _PreconditionActionExecutioner = require("../../../utils/PreconditionActionExecutioner");

var _RelevancesService = require("../../../KESI2/Services/RelevancesService");

var _NestedFlipTiles = _interopRequireDefault(require("./NestedFlipTiles.scss"));

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _TilesColorHelper = _interopRequireDefault(require("./TilesColorHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _DrupalNuggetBack = _interopRequireDefault(require("./DrupalNuggetBack"));

var _index = require("../../../KESI2/Services/RemoteControlService/index");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Spoc = require("../../../KESI2/entities/Spoc");

var _Course = require("../../../KESI2/entities/Course");

var _Lecture = require("../../../KESI2/entities/Lecture");

var _Constants = require("../../constants/Constants");

var _BuildConstants = require("../../../utils/BuildConstants");

var _AppUtils = require("../../../utils/AppUtils");

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _CssHelper = _interopRequireDefault(require("../../../helpers/CssHelper"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Z_INDEX = {
  BACKGROUND: 0,
  FOREGROUND: 1
};
var LEVELS = {
  ROOT: 'root',
  COURSE: 'course',
  SPOC: 'spoc',
  LECTURE: 'lecture'
};
var ALARM_ID = 'alarmEl';
var scrollPositionsOnClose = {};
var MIN_TIME_BETWEEN_TWO_POS_UPDATES = 700; // ms

var ANIMATION_DURATION = 1100; // ms; see css transitions

exports.ANIMATION_DURATION = ANIMATION_DURATION;
var INFO_BOX_ID = 'infoBox';

var DrupalTiles = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalTiles, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalTiles);

  function DrupalTiles(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalTiles);
    _this = _super.call(this, props, context, (0, _ArrayHelper.getLastElement)(props.contentPathArray));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfContentLocked", function () {
      var id = _KESI2Helper["default"].getLastSpocOrCourseId(_this.props.contentPathArray);

      var spocContent = _KESI2Helper["default"].getContentById(id);

      if (spocContent && spocContent.openPrecondition) {
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(spocContent.openPrecondition);

        if (failingPrecondition) {
          _NavigationManagerCordova["default"].goHome(false, null, 'DrupalTiles2');
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var el = document.activeElement;

        if (el) {
          var tileToOpen = el.children[0];

          if (tileToOpen) {
            var tileIdParts = tileToOpen.id.split('-');

            if (tileIdParts && tileIdParts.length > 1) {
              var id = tileIdParts[1].toString();

              var content = _KESI2Helper["default"].getContentById(id);

              console.log('content to open', tileIdParts, id, content);

              var openTileFn = _this.getOnOpenTile(content);

              if (openTileFn) openTileFn();
            }
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "receiveMessage", function (event) {
      if (event.data === 'scrolling down') {
        var el = document.getElementById(_this.getFrameElementId(_this.props.isInBackground));

        if (el) {
          el.scrollTop += _Constants.IFRAME_WHEEL_SCROLL_HEIGHT;
        }
      } else if (event.data === 'scrolling up') {
        var _el = document.getElementById(_this.getFrameElementId(_this.props.isInBackground));

        if (_el) {
          _el.scrollTop -= _Constants.IFRAME_WHEEL_SCROLL_HEIGHT;
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToTop", function () {
      var el = document.getElementById(_this.getScrollElementId(_this.props.isInBackground));
      el.scrollTop = 0;

      _this.setState({
        currentScrollTop: 0
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "preventScrolling", function (evt) {
      evt.target.scrollTop = _this.state.currentScrollTop;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "disableScrolling", function () {
      var el = document.getElementById(_this.getFrameElementId(_this.props.isInBackground));

      if (el) {
        if (!_BuildConstants.BUILT_FOR_BROWSER) {
          el.style.overflow = 'hidden'; // el.addEventListener('scroll', this.preventScrolling)

          return;
        }

        if (_config["default"].showSpocInfo) {
          el.style.transition = 'padding 500ms 1000ms';
          el.style.paddingTop = '0px';
        }

        _this.removeOverflowOnNavigationAllowed = true; // setTimeout(() => {
        //   console.log('removing overflow')
        //   el.style.removeProperty('overflow')
        // }, 1200)
      }

      var infoEl = document.getElementById(INFO_BOX_ID);

      if (infoEl && _config["default"].showSpocInfo) {
        infoEl.style.transition = 'opacity 500ms';
        infoEl.style.opacity = 0;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "enableScrolling", function () {
      var el = document.getElementById(_this.getFrameElementId(_this.props.isInBackground));

      if (!_BuildConstants.BUILT_FOR_BROWSER) {
        if (el) {// el.removeEventListener('scroll', this.preventScrolling)
        }

        return;
      }

      if (el) {
        el.style.overflow = 'auto';

        if (_config["default"].showSpocInfo) {
          el.style.transition = 'padding 0ms';
          el.style.paddingTop = '40px';
        }
      }

      var infoEl = document.getElementById(INFO_BOX_ID);

      if (infoEl && _config["default"].showSpocInfo) {
        infoEl.style.transition = 'opacity 500ms 500ms';
        infoEl.style.opacity = 1;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onWindowSizeChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _TimeoutHelper.timeout)(500);

            case 2:
              _this.viewOffsetAndSize = _this.getViewOffsetAndSize();
              _this.allowTransitionForFlippingTile = false;

              _this.forceUpdate();

              _context.next = 7;
              return (0, _TimeoutHelper.timeout)();

            case 7:
              _this.allowTransitionForFlippingTile = true;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "startAlarm", function () {
      if (!_this.state.playAlarmSound) {
        var sound = document.createElement('audio');
        sound.id = ALARM_ID;
        sound.src = './sounds/alert.wav';
        sound.type = 'audio/wav';
        sound.className = _NestedFlipTiles["default"].sound;
        sound.loop = true;
        document.body.appendChild(sound);
        console.log('startAlarm', sound);
        var el = document.getElementById(ALARM_ID);
        console.log('startAlarm', el);

        if (el) {
          el.play();
        }

        _this.setState({
          playAlarmSound: true
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "stopAlarm", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var el;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              el = document.getElementById(ALARM_ID);

              if (el && _this.state.playAlarmSound) {
                el.loop = false;
                el.pause();
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setZoomStyles", function () {
      var el = document.getElementById('tileRoot');
      var scrollFrames = document.getElementsByClassName('scrollFrame');
      var lectureFrame = document.getElementById('lecture_scroll_frame');

      if (el) {
        el.style.transform = 'perspective(1px) scale(2.0) translate3d(0,0,0)';
        el.style.paddingTop = "".concat(50 * 0.2, "px");

        for (var i = 0; i < scrollFrames.length; i++) {
          var screenHeight = el.offsetHeight;
          var screenWidth = el.offsetWidth;
          var neededWidth = 2 * _cssConstants["default"].appMaxWidth;
          var child = scrollFrames[i] && scrollFrames[i].children && scrollFrames[i].children.length > 0 ? scrollFrames[i].children[0] : null;

          if (child) {
            // TODO check width and height -> only if < 2x old height/ old width -> resize (best case might be px values here)
            var tileFrame = document.querySelector('[id^="tiles-frame2-not-background"]'); // because overflow is changing, the height is changing. Hardcoded for now...

            var neededHeight = 2 * 924; //tileFrame.offsetHeight

            child.style.height = "".concat((screenHeight + neededHeight - 50) / 2, "px");
            var calculatedWidthPercentage = ((neededWidth / screenWidth - 1) / 2 + 1) * 100;
            child.style.width = "".concat(calculatedWidthPercentage, "%");

            if (calculatedWidthPercentage > 100) {
              if (tileFrame) {
                var tileFrameChild = tileFrame && tileFrame.children && tileFrame.children.length > 0 ? tileFrame.children[0] : null;

                if (tileFrameChild) {
                  tileFrameChild.style.margin = '0';
                }
              }

              var lectureFrameChild = lectureFrame && lectureFrame.children && lectureFrame.children.length > 0 ? lectureFrame.children[0] : null;

              if (lectureFrameChild) {
                lectureFrameChild.style.margin = '0';
              }
            } else {
              if (tileFrame) {
                var _tileFrameChild = tileFrame && tileFrame.children && tileFrame.children.length > 0 ? tileFrame.children[0] : null;

                if (_tileFrameChild) {
                  _tileFrameChild.style.margin = "0 ".concat((100 - calculatedWidthPercentage) / 2, "%");
                }
              }

              var _lectureFrameChild = lectureFrame && lectureFrame.children && lectureFrame.children.length > 0 ? lectureFrame.children[0] : null;

              if (_lectureFrameChild) {
                _lectureFrameChild.style.margin = "0 ".concat((100 - calculatedWidthPercentage) / 2, "%");
              }
            }
          }
        }

        if (lectureFrame) {
          lectureFrame.style.height = '49%';
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onCloseTile", function () {
      // this.setState({tileTotallyFlipped: false})
      if (_this.props.goUpFunc) {
        _this.props.goUpFunc();
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getSpocInfo", function () {
      var spocCount = _KESI2Helper["default"].getSpocCount();

      var progress = null; // DataStore.pathExists(DATA_STORE_PATHS.KESI_ADDITIONAL_DATA) ? KESI2Helper.getSpocProgress(this.state.data.public.additionalData, id) : 0

      var infos = {
        count: spocCount || 0
      };
      return infos;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getLectureInfo", function () {
      var id = (0, _ArrayHelper.getLastElement)(_this.props.contentPathArray);

      var content = _KESI2Helper["default"].getContentById(id);

      var processTime = 0;
      content.lectureIds.forEach(function (lectureId) {
        var lectureContent = _KESI2Helper["default"].getContentById(lectureId);

        if (lectureContent.processTime && _config["default"].hiddenContentSubtype || lectureContent.processTime && lectureContent.subtype !== _config["default"].hiddenContentSubtype) {
          processTime += lectureContent.processTime;
        }
      });
      var count = 0;
      content.lectureIds.forEach(function (lectureId) {
        var lectureContent = _KESI2Helper["default"].getContentById(lectureId);

        if (lectureContent.subtype !== _config["default"].hiddenContentSubtype) {
          count++;
        }
      });
      var progress = null; // DataStore.pathExists(DATA_STORE_PATHS.KESI_ADDITIONAL_DATA) ? KESI2Helper.getSpocProgress(this.state.data.public.additionalData, id) : 0

      var infos = {
        count: count || 0,
        time: processTime,
        progress: progress
      };
      return infos;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "isCurrentLecture", function (lecture) {
      return (_this.currentLecture || {}).id === lecture.id;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "selectLanguage", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
        var url, index, newUrl, questionMarkIndex, _newUrl, _newUrl2;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = window.location.href;
                index = url.indexOf('lang=');

                if (!(index !== -1)) {
                  _context3.next = 9;
                  break;
                }

                newUrl = url.replace(/lang=\w{2}/, "lang=".concat(event.target.value));
                _context3.next = 6;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE, event.target.value);

              case 6:
                window.location.assign(newUrl);
                _context3.next = 21;
                break;

              case 9:
                questionMarkIndex = url.indexOf('.html?');

                if (!(questionMarkIndex === -1)) {
                  _context3.next = 17;
                  break;
                }

                _newUrl = url.replace(/index\.html/, "index.html?lang=".concat(event.target.value));
                _context3.next = 14;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE, event.target.value);

              case 14:
                window.location.assign(_newUrl);
                _context3.next = 21;
                break;

              case 17:
                _newUrl2 = url.replace(/index\.html\?/, "index.html?lang=".concat(event.target.value, "&"));
                _context3.next = 20;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE, event.target.value);

              case 20:
                window.location.assign(_newUrl2);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderInfoBox", function (level) {
      if (_this.tileOpen) {
        return null;
      }

      var infos = level === LEVELS.ROOT ? _this.getSpocInfo() : _this.getLectureInfo();
      var language = _this.state.data[_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE] || 'de';
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: INFO_BOX_ID,
        style: _DeviceInfoHelper["default"].isBrowser ? {
          maxWidth: _cssConstants["default"].appMaxWidth ? _cssConstants["default"].appMaxWidth : 1024,
          left: 'calc(50% - 10px)',
          transform: 'translateX(-50%)'
        } : {},
        className: _DeviceInfoHelper["default"].isBrowser() ? _NestedFlipTiles["default"].spocInfoBoxBrowser : _NestedFlipTiles["default"].spocInfoBox
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].lectureInfoContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].infoBox
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _NestedFlipTiles["default"].infoBoxIcon,
        name: "file-text"
      }), infos.count === 1 ? (0, _DrupalTilesStrings.getString)('LECTURE_COUNT_ONE') : (0, _DrupalTilesStrings.getString)('LECTURE_COUNT')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].lectureInfo
      }, infos.count)), infos && infos.time && infos.time > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].lectureInfoContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].infoBox
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        className: _NestedFlipTiles["default"].infoBoxIcon,
        name: "clock-o"
      }), (0, _DrupalTilesStrings.getString)('LECTURE_TIME')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NestedFlipTiles["default"].lectureInfo
      }, "".concat(infos.time, " min"))) : null, _config["default"].multiLanguage && /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: language,
        onChange: function onChange(event) {
          _this.selectLanguage(event);
        },
        inputProps: {
          name: 'languages'
        },
        MenuProps: {
          className: _NestedFlipTiles["default"].menu
        },
        className: _NestedFlipTiles["default"].select
      }, _config["default"].supportedLanguages.map(function (language) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: language,
          value: language
        }, language);
      })));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderExtraMenu", function () {
      var spocs = _KESI2Helper["default"].getAllSpocDataImmediately();

      var sortedSpocs = _this.sortElements(null, spocs);

      var currentPath = _NavigationManagerCordova["default"].getCurrentPath();

      var pathParts = currentPath.split('!');
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: pathParts && pathParts.length < 3 ? {
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'flex-start',
          maxHeight: '250px',
          padding: '10px',
          willChange: 'padding, max-height',
          transition: "padding 200ms ease-in-out ".concat(ANIMATION_DURATION + 200, "ms, max-height 200ms ease-in-out ").concat(ANIMATION_DURATION + 200, "ms")
        } : {
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'flex-start',
          maxHeight: 0,
          padding: '0 10px',
          willChange: 'padding, max-height',
          transition: "padding 200ms, max-height 200ms"
        }
      }, sortedSpocs && sortedSpocs.length > 0 && sortedSpocs.map(function (spoc) {
        var pathToChangeToFirst = null;

        if (pathParts.length > 2) {
          // we are in a lecture -> change to the spoc first, otherwise the routing wont work
          pathToChangeToFirst = "".concat(_config["default"].baseRoute, "/").concat(pathParts[0], "!").concat(pathParts[1]);
        }

        var isActive = currentPath.indexOf("".concat(_config["default"].rootId, "!").concat(spoc.id)) !== -1;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: spoc.id,
          className: _NestedFlipTiles["default"].heading,
          style: {
            opacity: isActive ? 1 : 0.5
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            fontFamily: _cssConstants["default"].headerFontFamily ? _cssConstants["default"].headerFontFamily : _cssConstants["default"].fontFamily
          },
          onClick: isActive ? function () {} : function () {
            _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId, "!").concat(spoc.id), pathToChangeToFirst);
          },
          dangerouslySetInnerHTML: {
            __html: spoc.title
          }
        }));
      }));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setTilesAsSeen", function (tiles) {
      _KESI2Helper["default"].setContentsAsSeen(tiles);
    });
    (0, _assign["default"])(_this.state, _objectSpread({
      flippingTileAbsolutePos: {
        x: 0,
        y: 0
      },
      isHidden: false,
      currentScrollTop: 0,
      sortedElements: [],
      tileVisibility: {},
      swipeIndex: 0,
      currentLectureIsEntering: true,
      currentLectureIsLeaving: false,
      enteringLeavingTransition: false,
      finishedTextVisible: true,
      snooReadLecturesCount: 0,
      playAlarmSound: false,
      openedTiles: [],
      contentZoomed: false,
      isInverted: false,
      tileTotallyFlipped: false
    }, _this.state));
    _this._id = _StringHelper["default"].createShortId();
    _this.flippingTilePosition = {};
    _this.flippingTileIds = [];
    _this.openLecture = null;
    _this.viewOffsetAndSize = {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    };
    _this.onNextComponentUpdate = null;
    _this.notifyAboutComponentUpdates = true;
    _this.isOpeningTransition = false;
    _this.isClosingTransitionForTile = false;
    _this.allowTransitionForFlippingTile = true;
    _this.currentLecture = null;
    _this.tileOpen = false;
    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    _this.removeOverflowOnNavigationAllowed = false;
    _this.lastPositionChange = 0;
    _this.isWritingNextSnooPushTitle = false;
    _this.scrollListener = _this.initScrollListener();
    _this.id = _StringHelper["default"].createShortId();
    _this.totallyFlipped = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalTiles.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.FILTER_FAVORITES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_LANGUAGE, _DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, _DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER, _DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES, _DataStore.DATA_STORE_PATHS.VB_ACTIVATED, _DataStore.DATA_STORE_PATHS.FFB_MACHINES, _DataStore.DATA_STORE_PATHS.FFB_EVENTS, 'private.i40.failureActive', 'public.azure', 'public.azure.groups']);
    return _this;
  }

  (0, _createClass2["default"])(DrupalTiles, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray);

      this.currentLecture = this.getCurrentLecture(contentTree);
      var state = {};
      state.contentTree = contentTree;
      state.sortedElements = this.initSortedTiles(this.props, contentTree, this.state.relevances);

      if (_config["default"].isSnooApp) {
        state.snooReadLecturesCount = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES) || 0;
      }

      this.viewOffsetAndSize = this.getViewOffsetAndSize();
      this.setState(state);

      if (_config["default"].showBottomBarOnlyInLecturesAndSpocs && _NavigationManagerCordova["default"].getCurrentId() === this.state.entityId) {
        var _this$getCurrentLevel = this.getCurrentLevelAndChapters(contentTree),
            level = _this$getCurrentLevel.level;

        (0, _AppUtils.hideBottomBar)(level === LEVELS.LECTURE);
      }

      _AppCordova["default"].addOnPageScrollListener(this.scrollListener, true);

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('message', this.receiveMessage, false);
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.onWindowSizeChanged);

        window.screen.orientation.addEventListener('change', this.onWindowSizeChanged);
      }

      if (_config["default"].storeSeenToContentStore) {
        this.setTilesAsSeen(state.sortedElements);
      }

      this.checkIfContentLocked();
      setTimeout(function () {
        _this2.setState({
          enteringLeavingTransition: true
        });
      }, 1000);
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(prevProps, prevState, snapshot) {
        var _this3 = this;

        var contentTree, _this$getCurrentLevel2, level, openedId, index, hideTileTransitions, scrollFrame, scrollEl, now, enoughTimePassed, el, _contentTree, state;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalTiles.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
                contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray);

                if (!this.state.data['private.i40.failureActive']) {
                  this.stopAlarm();
                }

                if (_config["default"].showBottomBarOnlyInLecturesAndSpocs && _NavigationManagerCordova["default"].getCurrentId() === this.state.entityId) {
                  _this$getCurrentLevel2 = this.getCurrentLevelAndChapters(contentTree), level = _this$getCurrentLevel2.level;
                  (0, _AppUtils.hideBottomBar)(level === LEVELS.LECTURE);
                }

                if (this.props.contentPathArray.length < prevProps.contentPathArray.length || this.openLecture !== null) {
                  // we did go back
                  if (this.openLecture) {
                    openedId = this.openLecture;
                    this.openLecture = null;
                  } else {
                    openedId = prevProps.contentPathArray[prevProps.contentPathArray.length - 1];
                  }

                  index = this.flippingTileIds.indexOf(openedId);
                  hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

                  if (index > -1) {
                    if (hideTileTransitions) {
                      (0, _ArrayHelper.removeElementAtPosition)(this.flippingTileIds, index);
                    } else {
                      setTimeout(function () {
                        (0, _ArrayHelper.removeElementAtPosition)(_this3.flippingTileIds, index); // const tileId = this.getTileIdForContent(openedId)
                        // delete this.flippingTilePosition[tileId]
                      }, ANIMATION_DURATION);
                    }
                  }
                }

                if (!((0, _ArrayHelper.getLastElement)(this.props.contentPathArray) === (0, _ArrayHelper.getLastElement)(prevProps.contentPathArray))) {
                  _context4.next = 40;
                  break;
                }

                if (!(this.props.flipped && !prevProps.flipped)) {
                  _context4.next = 13;
                  break;
                }

                this.isOpeningTransition = true;
                this.isClosingTransitionForTile = false;
                this.disableScrolling();
                this.tileOpen = true;
                _context4.next = 38;
                break;

              case 13:
                if (!(!this.props.flipped && prevProps.flipped)) {
                  _context4.next = 37;
                  break;
                }

                this.setState({
                  tileTotallyFlipped: false
                });
                this.totallyFlipped = false;
                _context4.next = 18;
                return (0, _TimeoutHelper.timeout)();

              case 18:
                this.isOpeningTransition = false;
                this.isClosingTransitionForTile = true;
                this.enableScrolling();
                this.tileOpen = false;
                scrollFrame = window.document.getElementById(this.getFrameElementId(this.props.isInBackground));

                if (this.props.isRoot) {
                  _context4.next = 27;
                  break;
                }

                scrollFrame.scrollTop = scrollPositionsOnClose[this._id] || 0;
                _context4.next = 34;
                break;

              case 27:
                _context4.next = 29;
                return (0, _TimeoutHelper.timeout)();

              case 29:
                this.setState({
                  tileVisibility: {}
                });
                _context4.next = 32;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES, false);

              case 32:
                // root scroll top will always be 0
                scrollEl = window.document.getElementById(this.getFrameElementId(this.props.isInBackground));
                scrollEl.scrollTop = scrollPositionsOnClose[this._id] || 0;

              case 34:
                if (contentTree.showCurrentLectureOnly) {
                  this.transitionForCurrentLecture(contentTree, this.state);
                }

                _context4.next = 38;
                break;

              case 37:
                if (!this.props.navigationAllowed && prevProps.navigationAllowed && prevProps.animated && !prevProps.animated) {
                  this.enableScrolling();
                }

              case 38:
                _context4.next = 42;
                break;

              case 40:
                this.isOpeningTransition = false;
                this.isClosingTransitionForTile = false;

              case 42:
                now = (0, _now["default"])(); // TODO: Not working for GWG -> closing Tile at wrong position

                enoughTimePassed = now - this.lastPositionChange > MIN_TIME_BETWEEN_TWO_POS_UPDATES;

                if (!(this.props.renderChildrenForId && (_config["default"].isSnooApp && enoughTimePassed || this.props.renderChildrenForId !== prevProps.renderChildrenForId))) {
                  _context4.next = 59;
                  break;
                }

                this.lastPositionChange = now;

                if (this.props.flipped) {
                  _context4.next = 50;
                  break;
                }

                this.viewOffsetAndSize = this.getViewOffsetAndSize();
                _context4.next = 57;
                break;

              case 50:
                if (!this.props.flipped) {
                  _context4.next = 57;
                  break;
                }

                this.viewOffsetAndSize = this.getViewOffsetAndSize();
                this.notifyAboutComponentUpdates = false;
                _context4.next = 55;
                return this.waitForNextComponentDidUpdate();

              case 55:
                this.notifyAboutComponentUpdates = true;

                if (this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES] && prevState.snooReadLecturesCount !== this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES]) {
                  this.state.snooReadLecturesCount = this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES];
                }

              case 57:
                _context4.next = 60;
                break;

              case 59:
                // else if (prevProps.isRoot && this.props.flipped && !prevProps.flipped) {
                //   console.log('flipped 2 viewOffsetAndSize')
                //
                //   const tileId = this.getTileIdForContent(this.props.renderChildrenForId)
                //   this.flippingTilePosition[tileId].top = 0
                // }
                if (_config["default"].isSnooApp && prevState.data[_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER] !== this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER]) {
                  if (!prevProps.flipped && this.props.flipped) {
                    setTimeout(function () {
                      var data = {};
                      data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES] = _this3.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES];

                      _DataStore["default"].setState(data);
                    }, 1200);
                  } else {
                    this.state.snooReadLecturesCount = this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES];
                  }
                }

              case 60:
                if (!(this.removeOverflowOnNavigationAllowed && this.props.navigationAllowed && !prevProps.navigationAllowed)) {
                  _context4.next = 69;
                  break;
                }

                el = document.getElementById(this.getFrameElementId(prevProps.isInBackground));

                if (!el) {
                  _context4.next = 69;
                  break;
                }

                el.style.removeProperty('overflow');
                this.forceUpdate();
                _context4.next = 67;
                return (0, _TimeoutHelper.timeout)(10);

              case 67:
                this.forceUpdate();
                this.removeOverflowOnNavigationAllowed = false;

              case 69:
                if (_config["default"].isSnooApp && prevState.data[_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER] !== this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_SCROLL_TOP_COUNTER]) {
                  this.scrollToTop();
                }

                this.state.contentTree = contentTree;
                this.state.sortedElements = this.initSortedTiles(this.props, contentTree, this.state.relevances);

                if (_config["default"].isSnooApp) {
                  this.saveNextSnooPushTitle(this.state.sortedElements, this.state.data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES]);
                }

                if (this.onNextComponentUpdate) {
                  this.onNextComponentUpdate();
                }

                if (this.notifyAboutComponentUpdates) {
                  this.props.onComponentDidUpdate();
                } // setTimeout(() => {
                //   CssHelper.removeCssRule('.container', `{transform: scale(1.0)`)
                //   CssHelper.addCssRule('.container', `{transform: scale(1.0)`)
                // }, 0)


                if (this.state.data[_DataStore.DATA_STORE_PATHS.VB_ACTIVATED] !== prevState.data[_DataStore.DATA_STORE_PATHS.VB_ACTIVATED]) {
                  console.log('we have a update in drupalTiles vb');
                  _contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray);
                  state = {};
                  state.contentTree = _contentTree;
                  state.sortedElements = this.initSortedTiles(this.props, _contentTree, this.state.relevances);
                  this.setState(state);
                }

              case 76:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2, _x3, _x4) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalTiles.prototype), "componentWillUnmount", this).call(this);

      _AppCordova["default"].removeOnPageScrollListener(this.scrollListener);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.onWindowSizeChanged);

        window.screen.orientation.removeEventListener('change', this.onWindowSizeChanged);
      } else {
        window.removeEventListener('keypress', function (event) {
          return _this4.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "transitionForCurrentLecture",
    value: function transitionForCurrentLecture(contentTree) {
      var _this5 = this;

      var currentLecture = this.getCurrentLecture(contentTree);
      var hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

      if (hideTileTransitions) {
        this.setState({
          currentLectureIsLeaving: true,
          currentLectureIsEntering: false,
          enteringLeavingTransition: true,
          finishedTextVisible: false
        });
        this.currentLecture = currentLecture;
        this.setState({
          currentLectureIsLeaving: false,
          currentLectureIsEntering: false,
          enteringLeavingTransition: false
        });

        if (currentLecture) {
          this.setState({
            enteringLeavingTransition: true,
            currentLectureIsLeaving: false,
            currentLectureIsEntering: true
          });
        } else {
          this.setState({
            finishedTextVisible: true
          });
        }
      } else {
        if (currentLecture !== this.currentLecture) {
          setTimeout(function () {
            _this5.setState({
              currentLectureIsLeaving: true,
              currentLectureIsEntering: false,
              enteringLeavingTransition: true,
              finishedTextVisible: false
            });

            setTimeout(function () {
              _this5.currentLecture = currentLecture;

              _this5.setState({
                currentLectureIsLeaving: false,
                currentLectureIsEntering: false,
                enteringLeavingTransition: false
              });
            }, 550);

            if (currentLecture) {
              setTimeout(function () {
                _this5.setState({
                  enteringLeavingTransition: true,
                  currentLectureIsLeaving: false,
                  currentLectureIsEntering: true
                });
              }, 800);
            } else {
              setTimeout(function () {
                _this5.setState({
                  finishedTextVisible: true
                });
              }, 800);
            }
          }, 1500);
        }
      }
    }
  }, {
    key: "initSortedTiles",
    value: function initSortedTiles(props, contentTree, relevances) {
      var contents = [];

      if (contentTree) {
        if (contentTree.courses) {
          contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.courses));
        }

        if (contentTree.spocs) {
          contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.spocs));
        }

        if (contentTree.lectures) {
          contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.lectures));
        }
      }

      var sortedElements = this.sortElements(props.contentPathArray, contents, relevances);
      return sortedElements;
    }
  }, {
    key: "saveNextSnooPushTitle",
    value: function () {
      var _saveNextSnooPushTitle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(sortedElements, snooReadLecturesCount) {
        var title, subtitle, secondNextChapter, prevTitle, prevSubtitle, data;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.isWritingNextSnooPushTitle) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                this.isWritingNextSnooPushTitle = true; // save next tile's title and subtitle to DataStore
                // This is used by the server to send a push message with the correct content

                title = null;
                subtitle = null;
                secondNextChapter = sortedElements[(snooReadLecturesCount || 0) + 1];

                if (secondNextChapter) {
                  title = secondNextChapter.title;
                  subtitle = secondNextChapter.subtitle;
                }

                prevTitle = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_NEXT_SPOC_TITLE);
                prevSubtitle = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_NEXT_SPOC_SUBTITLE);

                if (!(title !== prevTitle || subtitle !== prevSubtitle)) {
                  _context5.next = 18;
                  break;
                }

                data = {};
                data[_DataStore.DATA_STORE_PATHS.SNOO_NEXT_SPOC_TITLE] = title;
                data[_DataStore.DATA_STORE_PATHS.SNOO_NEXT_SPOC_SUBTITLE] = subtitle;

                if (title === null && subtitle === null) {
                  data[_DataStore.DATA_STORE_PATHS.SNOO_NO_MORE_PUSH_FOR_CONTENT] = true;
                } else if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_NO_MORE_PUSH_FOR_CONTENT)) {
                  // in case content was added
                  data[_DataStore.DATA_STORE_PATHS.SNOO_NO_MORE_PUSH_FOR_CONTENT] = false;
                }

                _context5.next = 16;
                return (0, _TimeoutHelper.timeout)(700);

              case 16:
                _context5.next = 18;
                return _DataStore["default"].setData(data);

              case 18:
                this.isWritingNextSnooPushTitle = false;

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveNextSnooPushTitle(_x5, _x6) {
        return _saveNextSnooPushTitle.apply(this, arguments);
      }

      return saveNextSnooPushTitle;
    }()
  }, {
    key: "getBasicStyle",
    value: function getBasicStyle(level, isInBackground) {
      var notAvailHeight = _config["default"].showBottomBar && !_config["default"].showBottomBarOnlyInLecturesAndSpocs ? _cssConstants["default"].bottomBarHeight + _cssConstants["default"].navBarHeight : _cssConstants["default"].navBarHeight;
      var style = {
        minHeight: level === LEVELS.ROOT ? null : "calc(100vh - ".concat(notAvailHeight, "px)"),
        height: level === LEVELS.ROOT ? "calc(100vh - ".concat(notAvailHeight, "px)") : 'auto',
        width: '100vw',
        overflow: 'auto',
        position: 'relative',
        // WebkitOverflowScrolling: 'touch',
        // paddingLeft: /* target.showBottomBar ? '32px' : */ null,
        paddingBottom: _config["default"].showBottomBar ? '64px' : '32px',
        background: _config["default"].tileBackgroundImage ? "url(".concat(_config["default"].tileBackgroundImageLight, ") no-repeat center") : null,
        backgroundSize: 'contain'
      };

      if (isInBackground) {
        // style.position = 'relative'
        style.overflow = 'hidden';
        style.zIndex = -1;
      }

      return style;
    }
  }, {
    key: "getBackgroundOverlayStyle",
    value: function getBackgroundOverlayStyle() {
      var style = {
        width: '100%',
        height: this.props.forcedHeight || 'calc(100vh - 64px)',
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        transition: 'background-color 500ms'
      };

      if (this.props.isInBackground && !this.props.isHidden) {
        style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      }

      return style;
    }
  }, {
    key: "getClassnamesForTile",
    value: function getClassnamesForTile() {
      return _NestedFlipTiles["default"].tile;
    }
  }, {
    key: "getClassnamesForFlippingTile",
    value: function getClassnamesForFlippingTile() {
      if (this.props.flipped) {
        return "".concat(_NestedFlipTiles["default"].tile, " ").concat(_NestedFlipTiles["default"].flipped);
      }

      return _NestedFlipTiles["default"].tile;
    }
  }, {
    key: "getFrameElementId",
    value: function getFrameElementId(isInBackground) {
      var background = isInBackground ? 'background' : 'not-background';
      return "tiles-frame2-".concat(background, "-").concat((0, _ArrayHelper.getLastElement)(this.props.contentPathArray));
    }
  }, {
    key: "getScrollElementId",
    value: function getScrollElementId(forBackground) {
      return "scroll-frame-".concat(forBackground ? 'background' : 'not-background', "-").concat((0, _ArrayHelper.getLastElement)(this.props.contentPathArray));
    }
  }, {
    key: "getStyleForTile",
    value: function getStyleForTile(chapter, size, centerChapter) {
      var _targetCSS$tiles, _targetCSS$tiles2;

      var extraMarginLeft = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var extraMarginRight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (size.height === 0) {
        return {
          container: {
            display: 'hidden'
          },
          tile: {
            display: 'hidden'
          }
        };
      }

      var width = size.width * this.props.zoomValue;
      var height = size.height * this.props.zoomValue;
      var margin = _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * this.props.zoomValue;
      var isVisible = false;

      if (this.props.showOnlyTileWithId && this.props.showOnlyTileWithId === chapter.id) {
        isVisible = true;
      }

      if (!this.props.showOnlyTileWithId && (chapter.id !== this.props.renderChildrenForId || !this.isOpeningTransition && !this.isClosingTransitionForTile)) {
        isVisible = true;
      }

      if (this.props.hideTileForId === chapter.id) {
        isVisible = false;
      }

      if (this.flippingTileIds.indexOf(chapter.id) > 0) {
        isVisible = false;
      }

      var index = this.props.contentPathArray.indexOf(chapter.id);

      if (index !== -1 && index < this.props.contentPathArray.length - 1) {
        isVisible = false;
      }

      var isFavorite = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA] && this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA][chapter.id] ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA][chapter.id].favorite : false;
      var showFavsOnly = this.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES];

      if (!isFavorite && showFavsOnly && chapter.type === 'lecture') {
        isVisible = false;
        height = 0;
        width = 0;
        margin = 0;
      }

      var tilePath = [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [chapter.id]);
      var chapterActive = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(chapter.id, ".", "".concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][chapter.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : chapter.active;
      var active = tilePath && chapterActive;

      if (!_config["default"].isKesiMaster && !_FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName)) {
        var masterFeature = _FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName);

        if (!active && !masterFeature && !_config["default"].isKesiMaster) {
          isVisible = false;
          height = 0;
          width = 0;
          margin = 0;
        }
      }

      if (chapter.type === 'lecture') {
        this.setTileVisibility(chapter.id, isVisible);
      }

      var widthToSet = Math.floor(width) % 2 === 0 ? Math.floor(width) : Math.floor(width) - 1;
      var heightToSet = Math.floor(height) % 2 === 0 ? Math.floor(height) : Math.floor(height) - 1;
      var marginToSet = Math.floor(margin) % 2 === 0 ? Math.floor(margin) : Math.floor(margin) - 1;
      var container = {
        width: widthToSet,
        height: heightToSet,
        marginTop: marginToSet,
        // don't combine these four margins as the overwrite below does not work when it changes from no overwriting to an overwriting
        marginBottom: marginToSet,
        marginLeft: marginToSet,
        marginRight: marginToSet,
        zIndex: Z_INDEX.BACKGROUND,
        opacity: isVisible ? 1 : 0,
        boxShadow: (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCSS$tiles = _cssConstants["default"].tiles) === null || _targetCSS$tiles === void 0 ? void 0 : _targetCSS$tiles.boxShadow) ? _cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCSS$tiles2 = _cssConstants["default"].tiles) === null || _targetCSS$tiles2 === void 0 ? void 0 : _targetCSS$tiles2.boxShadow : null,
        borderRadius: _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : ''
      };
      var hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

      if (extraMarginLeft) {
        container.marginLeft = extraMarginLeft;
      }

      if (extraMarginRight) {
        container.marginRight = extraMarginRight;
      }

      if (centerChapter) {
        container.position = 'relative';
        container.left = "calc(100vw + ".concat(margin, "px)");

        if (this.state.enteringLeavingTransition) {
          container.transition = hideTileTransitions ? 'none' : 'left 500ms';
        }

        if (this.state.currentLectureIsEntering) {
          container.left = "calc(50% - ".concat(margin, "px - ").concat(width / 2, "px)");
        } else if (this.state.currentLectureIsLeaving) {
          container.left = "-".concat(width + 2 * margin, "px");
        }
      }

      return {
        container: container,
        tile: {
          marginBottom: (_DrupalNestedTileSizes.LARGEST_TILE_SIZE - size.height) * this.props.zoomValue
        }
      };
    }
  }, {
    key: "getStyleForFlippingTile",
    value: function getStyleForFlippingTile(chapter, size) {
      if (size.height === 0) {
        return {
          display: 'hidden'
        };
      }

      var tileId = this.getTileIdForContent(this.props.renderChildrenForId);
      var tilePosition = this.flippingTilePosition[tileId] || this.getTilePosition(tileId);
      this.flippingTilePosition[tileId] = tilePosition;
      var outerScaleWidth = size.width / this.viewOffsetAndSize.width; // noinspection JSSuspiciousNameCombination --> this is intentional

      var outerScaleHeight = size.height / this.viewOffsetAndSize.width;
      var frontCounterScaleWidth = 1 / outerScaleWidth;
      var frontCounterScaleHeight = 1 / outerScaleHeight;
      var frontCounterSizeWidth = "".concat(100 / frontCounterScaleWidth, "%");
      var frontCounterSizeHeight = "".concat(100 / frontCounterScaleHeight, "%");
      var width;
      var height; // landscape

      if (this.viewOffsetAndSize.width > this.viewOffsetAndSize.height) {
        width = this.viewOffsetAndSize.width;
        height = this.viewOffsetAndSize.height * (this.viewOffsetAndSize.width / this.viewOffsetAndSize.height); // frontCounterSizeHeight = frontCounterSizeWidth;
      } // portrait
      else {
          width = this.viewOffsetAndSize.width;
          height = this.viewOffsetAndSize.height;
          frontCounterSizeHeight = "".concat(100 / frontCounterScaleHeight * (this.viewOffsetAndSize.width / this.viewOffsetAndSize.height), "%");
        }

      var widthToSet = Math.floor(width) % 2 === 0 ? Math.floor(width) : Math.floor(width) - 1;
      var heightToSet = Math.floor(height) % 2 === 0 ? Math.floor(height) : Math.floor(height) - 1;
      var style = {
        container: {
          width: widthToSet,
          height: heightToSet,
          // margin: MARGIN_BETWEEN_TILES,
          zIndex: Z_INDEX.FOREGROUND,
          position: 'absolute',
          margin: 'auto',
          left: tilePosition.left,
          top: tilePosition.top,
          // top: tilePosition.top - 13,  // for mazars dsgvo
          right: 'auto',
          bottom: 'auto',
          transform: "translate3d(0, 0, 0) scale(".concat(size.width / this.viewOffsetAndSize.width * this.props.zoomValue, ", ").concat(size.height / this.viewOffsetAndSize.width * this.props.zoomValue, ")"),
          transformOrigin: "top left",
          // boxShadow: targetCSS.tiles.boxShadow ? targetCSS.tiles.boxShadow : null,
          borderRadius: _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : ''
        },
        front: {
          transform: "scale(".concat(frontCounterScaleWidth, ", ").concat(frontCounterScaleHeight, ")"),
          width: frontCounterSizeWidth,
          height: frontCounterSizeHeight,
          transformOrigin: 'top left',
          overflow: 'hidden'
        },
        tile: {
          marginBottom: _DrupalNestedTileSizes.LARGEST_TILE_SIZE - size.height
        },
        back: {
          position: 'absolute',
          top: '0'
        }
      };
      var hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

      if (this.props.doNotRenderFlipping) {
        style = {
          container: {
            // margin: MARGIN_BETWEEN_TILES,
            width: width,
            height: height,
            zIndex: Z_INDEX.FOREGROUND,
            position: 'absolute',
            left: '-2000px',
            top: 0,
            transformOrigin: 'center',
            transform: 'rotateY(180deg)',
            transition: hideTileTransitions ? 'none' : 'left 1000ms ease-in-out, transform 1000ms 500ms ease-in-out',
            willChange: hideTileTransitions ? 'none' : 'left, transform'
          },
          front: {
            transformOrigin: 'top left',
            overflow: 'hidden',
            borderRadius: _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : ''
          },
          tile: {
            marginBottom: _DrupalNestedTileSizes.LARGEST_TILE_SIZE - size.height,
            transition: hideTileTransitions ? 'none' : 'all 1s 500ms, transform 1s'
          }
        };
      }

      if (this.props.animated && this.allowTransitionForFlippingTile && !this.props.doNotRenderFlipping) {
        style.tile.transition = hideTileTransitions ? 'none' : 'all 1s 500ms, transform 1s';
      } else {
        style.tile.transition = 'none';

        if (!this.props.doNotRenderFlipping) {
          style.container.transition = 'none';
        }
      }

      if (this.props.flipped) {
        var prevPosition = this.flippingTilePosition[tileId] || {
          top: 0,
          left: 0
        };
        var left = 0 - prevPosition.left - this.viewOffsetAndSize.left;
        var top = this.props.isRoot ? 0 : 0 - prevPosition.top - this.viewOffsetAndSize.top;

        if (this.props.doNotRenderFlipping) {
          // style.container.transform = `translate3d(${left + 2000}px, ${top}px, 0) scale(1.0)`
          var chapterId = chapter && chapter.id ? chapter.id : chapter;
          var elId = this.getTileIdForContent(chapterId, true);
          var el = document.getElementById(elId);
          setTimeout(function () {
            if (el) {
              el.style.left = 0;
              el.style.transform = 'rotateY(360deg) translateZ(10px)';
            }
          });
        } else {
          var scrollTop = 0;

          if (this.props.isRoot) {
            var frameEl = document.getElementById(this.getFrameElementId(this.props.isInBackground));
            scrollTop = (frameEl ? frameEl.scrollTop : 0) || document.documentElement.scrollTop;
          } else {
            var _frameEl = document.getElementById(this.props.scrollFrameId);

            scrollTop = _frameEl ? _frameEl.scrollTop : 0;
          }

          style.container.transform = "translate3d(".concat(left, "px, ").concat(top + scrollTop, "px, 0) scale(1.0)");
        }

        if (this.props.isRoot) {
          style.container.top = 0;
        }
      }

      return style;
    }
  }, {
    key: "getOnOpenTile",
    value: function getOnOpenTile(content) {
      var _this6 = this;

      var triesLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      var forceOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var failedPrecondition, continueOnFail, index, _spocContent$lectures, spocId, spocContent, filteredLectures, sd, colorToUse, scrollFrame, backgroundFrameId, foregroundFrameId, backgroundFrameEl, foregroundFrameEl, newPath, hideTileTransitions, rippleEffect;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (forceOpen) {
                  _context7.next = 6;
                  break;
                }

                failedPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
                continueOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failedPrecondition);

                if (!failedPrecondition) {
                  _context7.next = 6;
                  break;
                }

                (0, _PreconditionActionExecutioner.preconditionAction)(failedPrecondition, continueOnFail ? _this6.getOnOpenTile(content, triesLeft, continueOnFail) : function () {});
                return _context7.abrupt("return");

              case 6:
                if (!(triesLeft === 0)) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt("return");

              case 8:
                if (!(content.id === _this6.props.renderChildrenForId && _this6.props.flipped)) {
                  _context7.next = 10;
                  break;
                }

                return _context7.abrupt("return");

              case 10:
                if (_this6.props.navigationAllowed) {
                  _context7.next = 14;
                  break;
                }

                _context7.next = 13;
                return (0, _TimeoutHelper.timeout)(200);

              case 13:
                return _context7.abrupt("return", _this6.getOnOpenTile(content, triesLeft - 1, forceOpen)());

              case 14:
                if (_config["default"].isInScorm) {
                  index = _this6.state.openedTiles.indexOf(content.id);

                  if (index < 0) {
                    _this6.state.openedTiles.push(content.id);

                    spocId = _this6.props.contentPathArray[_this6.props.contentPathArray.length - 1];
                    spocContent = _KESI2Helper["default"].getContentById(spocId);
                    filteredLectures = spocContent === null || spocContent === void 0 ? void 0 : (_spocContent$lectures = spocContent.lectures) === null || _spocContent$lectures === void 0 ? void 0 : _spocContent$lectures.filter(function (lecture) {
                      return lecture.subtype !== 'glossary';
                    });

                    if (filteredLectures && filteredLectures.length === _this6.state.openedTiles.length) {
                      sd = window.parent;

                      if (sd) {
                        sd.SetPassed();
                        sd.SetReachedEnd();
                        sd.CommitData();
                      }
                    }
                  }
                }

                if (content.keyword === 'alarm' && _this6.state.playAlarmSound) {
                  _this6.stopAlarm();
                }

                if (_config["default"].useTileBackgroundColorInTile) {
                  if (content && (content.backgroundColor || content.innerColor)) {
                    colorToUse = content.innerColor ? content.innerColor : content.backgroundColor;

                    _NavigationManagerCordova["default"].setNavbarBackgroundColor(colorToUse);
                  }
                }

                _this6.flippingTileIds.push(content.id);

                if (!content.externalURL) {
                  _context7.next = 21;
                  break;
                }

                window.open(content.externalURL, '_system');
                return _context7.abrupt("return");

              case 21:
                scrollFrame = window.document.getElementById(_this6.getFrameElementId(_this6.props.isInBackground));
                scrollPositionsOnClose[_this6._id] = scrollFrame.scrollTop; // opening tile

                backgroundFrameId = _this6.getFrameElementId(true);
                foregroundFrameId = _this6.getFrameElementId(false);
                backgroundFrameEl = document.getElementById(backgroundFrameId);
                foregroundFrameEl = document.getElementById(foregroundFrameId);

                if (backgroundFrameEl && foregroundFrameEl) {
                  backgroundFrameEl.scrollTop = foregroundFrameEl.scrollTop;
                }

                newPath = [].concat((0, _toConsumableArray2["default"])(_this6.props.contentPathArray), [content.id]);

                _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(newPath.join(_KesiConstants.KESI_PATH_DELIMITER)));

                _context7.next = 32;
                return (0, _TimeoutHelper.timeout)();

              case 32:
                hideTileTransitions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

                if (hideTileTransitions) {
                  if (content.type === LEVELS.LECTURE) {
                    _this6.openLecture = content.id;
                  }
                } else {
                  setTimeout(function () {
                    if (content.type === LEVELS.LECTURE) {
                      _this6.openLecture = content.id;

                      var isZoomed = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.IS_ZOOMED);

                      if (isZoomed) {
                        setTimeout(function () {
                          _this6.setZoomStyles();
                        });
                      }
                    }

                    console.log('ANIMATION_DURATION_DONE');

                    _this6.setState({
                      tileTotallyFlipped: true
                    });

                    _this6.totallyFlipped = true;
                  }, ANIMATION_DURATION);
                }

                rippleEffect = /*#__PURE__*/function () {
                  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                    var flippingTile, rippleNew;
                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            flippingTile = document.getElementById(_this6.getTileIdForContent(content.id, true, true));

                            if (flippingTile) {
                              _context6.next = 5;
                              break;
                            }

                            _context6.next = 4;
                            return (0, _TimeoutHelper.timeout)(50);

                          case 4:
                            return _context6.abrupt("return", rippleEffect());

                          case 5:
                            // Add the element
                            rippleNew = document.createElement('SPAN');
                            rippleNew.classList.add(_NestedFlipTiles["default"].ripple);
                            flippingTile.appendChild(rippleNew);
                            rippleNew.classList.add(_NestedFlipTiles["default"].rippleEffect);
                            return _context6.abrupt("return", _promise["default"].resolve());

                          case 10:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function rippleEffect() {
                    return _ref5.apply(this, arguments);
                  };
                }();

                return _context7.abrupt("return", rippleEffect());

              case 36:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }, {
    key: "getTileIdForContent",
    value: function getTileIdForContent(contentId, mayFlip) {
      var forFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var prefix = mayFlip ? 'flipping-' : '';
      var background = this.props.isInBackground ? '_background' : '';
      var front = forFront ? '_front' : '';
      return "".concat(prefix, "tile-").concat(contentId).concat(front).concat(background);
    }
  }, {
    key: "getTilePosition",
    value: function getTilePosition(domId) {
      var top = 0;
      var left = 0; // find that tile and remember position

      var element = document.getElementById(domId);
      var frame = document.getElementById(this.getFrameElementId(this.props.isInBackground));

      if (element && element.parentNode && frame) {
        top = this.props.isRoot ? element.parentNode.offsetTop - this.props.rootScrollTop : element.parentNode.offsetTop - frame.scrollTop; // + Number(window.getComputedStyle(element.parentNode).marginTop.replace('px', ''));

        left = element.parentNode.offsetLeft;
      }

      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "getTileSize",
    value: function getTileSize(parentPath, contentId) {
      var relevance = _RelevancesService.DEFAULT_RELEVANCE;

      if (this.state.relevances) {
        relevance = this.state.relevances[[].concat((0, _toConsumableArray2["default"])(parentPath), [contentId]).join(_KesiConstants.KESI_PATH_DELIMITER)] || this.state.relevances._default || _RelevancesService.DEFAULT_RELEVANCE;
      }

      var content = _KESI2Helper["default"].getContentById(contentId);

      if (_config["default"].targetTileSize) {
        return {
          width: _config["default"].targetTileSize,
          height: _config["default"].targetTileSize
        };
      }

      if (content && relevance > 66 && relevance <= 100) {
        return {
          width: content.keyword === _DrupalNestedTileSizes.LANDSCAPE_FULL ? _DrupalNestedTileSizes.FULL_SIZE_TILE_SIZE : _DrupalNestedTileSizes.TILE_SIZES.LARGE,
          height: _DrupalNestedTileSizes.TILE_SIZES.LARGE
        };
      }

      if (content && relevance > 33) {
        return {
          width: content.keyword === _DrupalNestedTileSizes.LANDSCAPE_FULL ? _DrupalNestedTileSizes.FULL_SIZE_TILE_SIZE : _DrupalNestedTileSizes.TILE_SIZES.MEDIUM,
          height: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM
        };
      }

      if (content && relevance >= 0) {
        return {
          width: content.keyword === _DrupalNestedTileSizes.LANDSCAPE_FULL ? _DrupalNestedTileSizes.FULL_SIZE_TILE_SIZE : _DrupalNestedTileSizes.TILE_SIZES.SMALL,
          height: _DrupalNestedTileSizes.TILE_SIZES.SMALL
        };
      }

      if (content && relevance === -1) {
        return {
          width: content.keyword === _DrupalNestedTileSizes.LANDSCAPE_FULL ? _DrupalNestedTileSizes.FULL_SIZE_TILE_SIZE : _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE,
          height: _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE
        };
      }

      return {
        width: _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE,
        height: _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE
      };
    }
  }, {
    key: "getUsageCountStyle",
    value: function getUsageCountStyle() {
      return {
        opacity: this.props.isInBackground || this.props.flipped || this.props.hideTileForId ? 0 : 1,
        transition: 'opacity 200ms'
      };
    }
  }, {
    key: "getViewOffsetAndSize",
    value: function getViewOffsetAndSize() {
      var width = 0;
      var height = 0;
      var top = 0;
      var left = 0;
      var frameElement = document.getElementById(this.getFrameElementId(this.props.isInBackground));

      if (frameElement) {
        if (frameElement.offsetTop) {
          top = frameElement.offsetTop;
        } else {
          // find parent with top offset
          var _parent = frameElement.parentNode;

          while (_parent) {
            if (_parent.offsetTop) {
              top = _parent.offsetTop;
              break;
            }

            if (!_parent.parentNode) {
              break;
            }

            _parent = _parent.parentNode;
          }

          if (!top) {
            console.warn("no offset top for element with id ".concat(this.getFrameElementId(this.props.isInBackground), " or any parent -- is there no nav bar?"));
          }
        }

        if (frameElement.offsetLeft) {
          left = frameElement.offsetLeft;
        }

        if (frameElement.offsetWidth > 0) {
          width = frameElement.offsetWidth;
        }

        if (frameElement.offsetHeight > 0) {
          height = frameElement.offsetHeight;
        }

        var parent = frameElement.parentNode;

        while (parent) {
          if (!width && parent.offsetWidth > 0) {
            width = parent.offsetWidth;
          }

          if (!height && parent.offsetHeight > 0) {
            height = parent.offsetHeight;
          }

          if (width && height) {
            break;
          }

          parent = parent.parentNode;
        }
      }

      if (!this.props.isRoot || !this.props.doNotRenderFlipping) {
        top = frameElement ? frameElement.scrollTop : 0;
      }

      return {
        top: top,
        left: left,
        width: width,
        height: height
      };
    }
  }, {
    key: "initScrollListener",
    value: function initScrollListener() {
      var _this7 = this;

      return function (scrollTop) {
        _this7.setState({
          currentScrollTop: scrollTop
        });
      };
    }
  }, {
    key: "setTileVisibility",
    value: function setTileVisibility(chapterId, isVisible) {
      var _this8 = this;

      var tileVisibility = this.state.tileVisibility;

      if (tileVisibility[chapterId] !== isVisible) {
        tileVisibility[chapterId] = isVisible;
        setTimeout(function () {
          _this8.setState({
            tileVisibility: tileVisibility
          });
        });
      }
    }
  }, {
    key: "shouldRenderBack",
    value: function shouldRenderBack(chapter) {
      return chapter.id === this.props.renderChildrenForId;
    }
  }, {
    key: "waitForNextComponentDidUpdate",
    value: function () {
      var _waitForNextComponentDidUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.onNextComponentUpdate = function () {
                  return _promise["default"].resolve();
                };

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function waitForNextComponentDidUpdate() {
        return _waitForNextComponentDidUpdate.apply(this, arguments);
      }

      return waitForNextComponentDidUpdate;
    }()
  }, {
    key: "sortElements",
    value: function sortElements(parentPath, contents, relevances) {
      if (_config["default"].sortAlphabetically) {
        return contents.sort(function (content1, content2) {
          if (content1.title < content2.title) {
            return -1;
          }

          if (content1.title > content2.title) {
            return 1;
          }

          return 0;
        });
      }

      if (_config["default"].sortById) {
        return contents.sort(function (content1, content2) {
          return content1.id - content2.id;
        });
      }

      var isSpocLevel = Boolean(contents.find(function (content) {
        return content.type === _Spoc.TYPE || content.type === _Course.TYPE || content.type === _Lecture.TYPE;
      }));

      if (_config["default"].sortByOrderField) {
        return contents.sort(function (content1, content2) {
          if ((content1.order || content1.order === 0) && (content2.order || content2.order === 0)) {
            if (content1.order < content2.order) {
              return -1;
            }

            if (content1.order > content2.order) {
              return 1;
            }

            return 0;
          } else {
            // Don't bring up id sorting here!
            // This piece of code is used for lecture-in-spoc sorting, too and we want to keep the author's order there
            return 0;
          }
        });
      }

      if (!relevances || (0, _keys["default"])(relevances).length === 0) {
        return contents;
      }

      return contents.map(function (content) {
        return {
          content: content,
          relevance: relevances[[].concat((0, _toConsumableArray2["default"])(parentPath), [content.id]).join(_KesiConstants.KESI_PATH_DELIMITER)]
        };
      }).sort(function (element1, element2) {
        if (element1.relevance > element2.relevance) {
          return -1;
        }

        if (element1.relevance < element2.relevance) {
          return 1;
        }

        return 0;
      }).map(function (element) {
        return element.content;
      });
    }
  }, {
    key: "renderTileBack",
    value: function renderTileBack(content, style) {
      if (this.shouldRenderBack(content)) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(this.isInternetExplorer ? _NestedFlipTiles["default"].backIE : _NestedFlipTiles["default"].back, " ").concat(this.props.flipped ? _NestedFlipTiles["default"].backFlipped : ''),
          style: style
        }, /*#__PURE__*/_react["default"].createElement(DrupalTiles, {
          contentPathArray: [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [content.id]),
          flipped: false,
          setCount: this.props.setCount,
          zoomValue: this.props.zoomValue,
          goUpFunc: this.props.goUpFunc,
          showGoUpButton: this.props.showGoUpButtonOnBack,
          showGoUpButtonOnBack: this.props.showGoUpButtonOnBack,
          navigationAllowed: this.props.navigationAllowed,
          setShowFavButton: this.props.setShowFavButton,
          setBackButtonFunc: this.props.setBackButtonFunc
        }));
      }

      return null;
    }
  }, {
    key: "renderFlippingTile",
    value: function renderFlippingTile(content, style) {
      var size = this.getTileSize(this.props.contentPathArray, content.id); // this is special handling for the "Störfall" Kachel in Industrie 4.0

      if (content.keyword === 'alarm' && content.unhighlightCondition && (0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition)) {
        size = {
          width: _DrupalNestedTileSizes.TILE_SIZES.LARGE + 100,
          height: _DrupalNestedTileSizes.TILE_SIZES.LARGE + 100
        };
        content.backgroundColor = 'red';
        content.titleBackgroundColor = 'red';
        content.additionalClassName = _NestedFlipTiles["default"].blinkyBlinky;

        if (this.state.playAlarmSound) {
          this.stopAlarm();
        }
      } else {
        content.additionalClassName = null;
      }

      var extraClassName = content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition) ? _NestedFlipTiles["default"].grayscale : '';
      var key = this.getTileIdForContent(content.id, true);
      var tilePath = [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [content.id]);
      var hideAnimation = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
      var forcedUIColor;

      if (_config["default"].useTileBackgroundColorInTile && content.backgroundColor) {
        forcedUIColor = content.backgroundColor;
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getTileIdForContent(content.id, true),
        key: key,
        className: "".concat(_NestedFlipTiles["default"].flippableContainer, " container").concat(hideAnimation ? " ".concat(_NestedFlipTiles["default"].noAnimation) : ''),
        style: style.container
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: key,
        className: this.getClassnamesForFlippingTile(content),
        style: style.tile
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getTileIdForContent(content.id, true, true),
        className: "".concat(_NestedFlipTiles["default"].front, " ").concat(extraClassName, " ").concat(this.props.flipped && this.isInternetExplorer ? _NestedFlipTiles["default"].frontFlipped : '').concat(hideAnimation ? " ".concat(_NestedFlipTiles["default"].noAnimation) : ''),
        style: style.front
      }, /*#__PURE__*/_react["default"].createElement(_NuggetFront["default"], {
        id: content.id,
        size: size.height,
        correctedSize: size.height * this.props.zoomValue,
        keywords: content.keyword,
        icon: content.svgIcon ? content.svgIcon : content.icon,
        enhancedIcon: content.enhancedSvgIcon ? content.enhancedSvgIcon : content.enhancedIcon,
        background: content.background,
        enhancedBackground: content.enhancedBackground,
        backgroundColored: content.backgroundColored,
        enhancedBackgroundColored: content.enhancedBackgroundColored,
        backgroundColor: content.backgroundColor,
        titleBackgroundColor: content.titleBackgroundColor,
        additionalClassName: content.additionalClassName,
        title: content.title,
        subtitle: content.subtitle,
        glows: false,
        colorClasses: _TilesColorHelper["default"].getColorFromKey(content.keyword, content.id),
        zoomValue: 1.0,
        type: content.type,
        processTime: content.processTime,
        active: content.active,
        contentPathArray: tilePath,
        isGrayScale: content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition),
        forcedUIColor: forcedUIColor,
        isPublished: content.isPublished
      })), this.renderTileBack(content, style.back))));
    }
  }, {
    key: "renderGoUpButton",
    value: function renderGoUpButton() {
      var _this9 = this;

      if (!this.props.showGoUpButton) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NestedFlipTiles["default"].tilesButtonsClose, " ").concat(this.props.showGoUpButton ? '' : _NestedFlipTiles["default"].hiddenByOpacity)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        onClick: function onClick() {
          return _this9.onCloseTile();
        },
        className: _NestedFlipTiles["default"].closeButton
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "times"
      })));
    }
  }, {
    key: "renderTile",
    value: function renderTile(content) {
      var _this10 = this;

      var forcedSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var centerTile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var hasFlippingTile = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if ((0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition)) {
        return null;
      }

      var readTileCount = this.state.snooReadLecturesCount;

      if (index !== null && _config["default"].showLecturesOneByOne && readTileCount < index) {
        return null;
      }

      if (_config["default"].hiddenContentSubtype && content.subtype === _config["default"].hiddenContentSubtype) {
        return null;
      }

      var size = forcedSize || this.getTileSize(this.props.contentPathArray, content.id); // this is special handling for the "Störfall" Kachel in Industrie 4.0

      if (content.keyword === 'alarm' && content.unhighlightCondition && (0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition)) {
        console.log('we got an alarm tile', size, _DrupalNestedTileSizes.TILE_SIZES.LARGE);
        size = {
          width: _DrupalNestedTileSizes.TILE_SIZES.LARGE + 100,
          height: _DrupalNestedTileSizes.TILE_SIZES.LARGE + 100
        };
        content.backgroundColor = 'red';
        content.titleBackgroundColor = 'red';
        content.additionalClassName = _NestedFlipTiles["default"].blinkyBlinky;

        if (!this.state.playAlarmSound) {
          this.startAlarm();
        }
      } else {
        content.additionalClassName = null;
      }

      var tileId = this.getTileIdForContent(content.id);
      var tilePosition = this.getTilePosition(tileId);
      this.flippingTilePosition[tileId] = tilePosition;
      var extraMarginLeft = null;
      var extraMarginRight = null;

      if (_config["default"].fillUpTileRows && index === (_config["default"].reverseLectureOrder ? readTileCount : 0) && this.props.colCount > 1) {
        var visibleTileCount = readTileCount + 1;
        var rest = visibleTileCount % this.props.colCount;

        if (visibleTileCount % this.props.colCount !== 0) {
          extraMarginLeft = (0.5 * (this.props.colCount - rest) * _DrupalNestedTileSizes.TILE_SIZES.LARGE + 3 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES) * this.props.zoomValue;
          extraMarginRight = 20 * this.props.zoomValue;
        }
      }

      var style = this.getStyleForTile(content, size, centerTile, extraMarginLeft, extraMarginRight);
      var extraClassName = content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition) ? this.props.isInBackground ? _NestedFlipTiles["default"].test : _NestedFlipTiles["default"].grayscale : '';
      var key = this.getTileIdForContent(content.id, false);
      var tilePath = [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [content.id]);

      var feature = _FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName);

      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(content.id, ".", "".concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][content.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : content.active;
      var hideAnimation = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
      var forcedUIColor;

      if (_config["default"].useTileBackgroundColorInTile && content.backgroundColor) {
        forcedUIColor = content.backgroundColor;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: key,
        className: "".concat(_NestedFlipTiles["default"].container, " ").concat(extraClassName, " container").concat(hideAnimation ? " ".concat(_NestedFlipTiles["default"].noAnimation) : ''),
        style: style.container,
        tabIndex: _config["default"].hideFlippedTileBackground && this.props.flipped ? -1 : 0
      }, (_config["default"].isKesiMaster || feature !== null) && /*#__PURE__*/_react["default"].createElement("img", {
        className: _NestedFlipTiles["default"].activateIcon,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
          return _regenerator["default"].wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(content.id, ".").concat(_this10.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), !active);

                case 2:
                  _context9.next = 4;
                  return _KESI2Helper["default"].setVisibilities(_this10.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]);

                case 4:
                  (0, _index.pushActivateMessage)(_this10.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES], content.id, tilePath, !active);

                case 5:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        })),
        src: active ? require('./assets/visible_true.svg') : require('./assets/visible_false.svg')
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: key,
        className: this.getClassnamesForTile(content),
        onClick: this.getOnOpenTile(content),
        style: style.tile
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NestedFlipTiles["default"].front, " ").concat(this.props.flipped && this.isInternetExplorer ? _NestedFlipTiles["default"].frontFlipped : '').concat(hideAnimation ? " ".concat(_NestedFlipTiles["default"].noAnimation) : ''),
        style: style.front
      }, /*#__PURE__*/_react["default"].createElement(_NuggetFront["default"], {
        id: content.id,
        size: size.height,
        correctedSize: size.height * this.props.zoomValue,
        keywords: content.keyword,
        icon: content.svgIcon ? content.svgIcon : content.icon,
        enhancedIcon: content.enhancedSvgIcon ? content.enhancedSvgIcon : content.enhancedIcon,
        background: content.background,
        enhancedBackground: content.enhancedBackground,
        backgroundColored: content.backgroundColored,
        enhancedBackgroundColored: content.enhancedBackgroundColored,
        backgroundColor: content.backgroundColor,
        titleBackgroundColor: content.titleBackgroundColor,
        title: content.title,
        subtitle: content.subtitle,
        glows: false,
        colorClasses: _TilesColorHelper["default"].getColorFromKey(content.keyword, content.id),
        zoomValue: _DeviceInfoHelper["default"].isInternetExplorer() ? 1.0 : this.props.zoomValue,
        type: content.type,
        processTime: content.processTime,
        active: content.active,
        contentPathArray: tilePath,
        isGrayScale: content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition),
        additionalClassName: content.additionalClassName,
        forcedUIColor: forcedUIColor,
        isPublished: content.isPublished,
        parentHasOpenTile: this.props.flipped
      }))));
    }
  }, {
    key: "setUsageCount",
    value: function setUsageCount(props, state) {
      if (props.isInBackground
      /* || props.flipped */
      ) {
          return;
        }

      if (state.usages) {
        var idToCheck = props.flipped ? props.renderChildrenForId : (0, _ArrayHelper.getLastElement)(props.contentPathArray);
        var count = state.usages[idToCheck]; // const course = this.props.spocTreePartial;
        // let chapters;
        // if (course.spocs) {
        //   chapters = course.spocs;
        // }
        // else if (course.lectures) {
        //   chapters = course.lectures;
        // }
        // chapters.forEach((child) => {
        //   ownCount -= this.state.usages[child.id];
        // });
        //

        if (count >= 0 && this.props.navigationAllowed) {
          props.setCount(count);
        }
      }
    }
  }, {
    key: "getCurrentLecture",
    value: function getCurrentLecture(spoc) {
      if (!spoc || !spoc.lectures) {
        return null;
      } // let alternativeLastLecture = null


      var currentLecture = spoc.lectures.find(function (lectureInSpoc) {
        // alternativeLastLecture = lectureInSpoc
        var isRead = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(lectureInSpoc);

        return !isRead;
      });
      return currentLecture; // || alternativeLastLecture
    }
  }, {
    key: "getCurrentLevelAndChapters",
    value: function getCurrentLevelAndChapters(contentTree) {
      var level;
      var chapters = [];

      if (contentTree.courses) {
        chapters.push.apply(chapters, (0, _toConsumableArray2["default"])(contentTree.courses));
        level = LEVELS.ROOT;
      } else if (contentTree.spocs) {
        chapters.push.apply(chapters, (0, _toConsumableArray2["default"])(contentTree.spocs));

        if (contentTree.lectures) {
          chapters.push.apply(chapters, (0, _toConsumableArray2["default"])(contentTree.lectures));
        }

        level = _config["default"].usesCourses ? LEVELS.COURSE : LEVELS.ROOT;
      } else if (contentTree.lectures) {
        chapters.push.apply(chapters, (0, _toConsumableArray2["default"])(contentTree.lectures));
        level = LEVELS.SPOC;
      } else {
        level = LEVELS.LECTURE;
      }

      return {
        level: level,
        chapters: chapters
      };
    }
  }, {
    key: "renderShield",
    value: function renderShield(id, spocContent) {
      return null;
    }
  }, {
    key: "renderOuterShield",
    value: function renderOuterShield(id, spocContent) {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      this.setUsageCount(this.props, this.state);

      var contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray);

      var flippingTileChapter = null;

      if (this.props.renderChildrenForId) {
        if ((contentTree === null || contentTree === void 0 ? void 0 : contentTree.id) === this.props.renderChildrenForId) {
          flippingTileChapter = contentTree;
        } else {
          var contents = [];

          if (contentTree.courses) {
            contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.courses));
          }

          if (contentTree.spocs) {
            contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.spocs));
          }

          if (contentTree.lectures) {
            contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.lectures));
          }

          flippingTileChapter = contents ? contents.find(function (content) {
            return content.id === _this11.props.renderChildrenForId;
          }) : null;
        }
      }

      var flippingStyle;

      if (flippingTileChapter) {
        var size = this.getTileSize(this.props.contentPathArray, flippingTileChapter.id);
        flippingStyle = this.getStyleForFlippingTile(flippingTileChapter.id, size);
      }

      if (!contentTree) {
        console.error("content tree to render is null! content path is ".concat((0, _stringify["default"])(this.props.contentPathArray)));

        _NavigationManagerCordova["default"].goHome();

        (0, _AlertHelper.showAlertWithOptions)({
          message: (0, _DrupalTilesStrings.getString)('CONTENT_NOT_FOUND_MESSAGE'),
          title: (0, _DrupalTilesStrings.getString)('CONTENT_NOT_FOUND')
        }); // showAlert(getString('CONTENT_NOT_FOUND_MESSAGE'), getString('CONTENT_NOT_FOUND'))

        return null;
      }

      var _this$getCurrentLevel3 = this.getCurrentLevelAndChapters(contentTree),
          chapters = _this$getCurrentLevel3.chapters,
          level = _this$getCurrentLevel3.level;

      var renderFinishedText = false;

      if (chapters && chapters.length > 0) {
        var tiles;

        if (contentTree.showCurrentLectureOnly) {
          var index = null;
          var currentLecture = this.props.renderFront && this.state.sortedElements ? this.state.sortedElements.find(function (chapter, i) {
            if (_this11.isCurrentLecture(chapter)) {
              index = i;
              return chapter;
            }

            return null;
          }) : null;

          if (currentLecture) {
            tiles = [this.renderTile(currentLecture, null, true, index, flippingTileChapter)].filter(function (tile) {
              return tile !== null;
            });
          }

          if (!currentLecture || tiles.length === 0) {
            renderFinishedText = true;
          }
        } else {
          var uppestLectureIndex = null;
          tiles = this.props.renderFront && this.state.sortedElements ? this.state.sortedElements.map(function (chapter, index) {
            var tile = _this11.renderTile(chapter, null, false, index, index === _this11.state.sortedElements.length - 1);

            if (tile !== null) {
              uppestLectureIndex = chapter.id;
            }

            return tile;
          }).filter(function (tile) {
            return tile !== null;
          }) : null;

          if (_config["default"].showLecturesOneByOne) {
            if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_UPPEST_LECTURE_ID) !== uppestLectureIndex) {
              _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SNOO_UPPEST_LECTURE_ID, uppestLectureIndex, false);
            }
          }
        }

        if (tiles && level === LEVELS.SPOC && _config["default"].reverseLectureOrder) {
          tiles.reverse();
        }

        var flippingTile = flippingTileChapter ? this.renderFlippingTile(flippingTileChapter, flippingStyle) : null;
        var goUpButton = this.props.renderFront ? this.renderGoUpButton() : null;
        var oneTileVisible = (0, _keys["default"])(this.state.tileVisibility).some(function (key) {
          return _this11.state.tileVisibility[key];
        });

        if (!oneTileVisible && (0, _keys["default"])(this.state.tileVisibility).length > 0 && this.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES]) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              maxWidth: '70%',
              margin: '0 auto'
            },
            className: _NestedFlipTiles["default"].noTilesText
          }, (0, _DrupalTilesStrings.getString)('NO_FAVS'));
        } // const allDone = KESI2Helper.checkIfAllContentDone(this.state)


        var showingTiles = _config["default"].showSpocInfo && level === LEVELS.SPOC;
        var showExtraMenu = _config["default"].showSpocsInExtraMenu && level === LEVELS.SPOC;
        var paddingObj = showExtraMenu ? {
          paddingLeft: 'calc((100vw - 1280px) / 2)',
          paddingRight: 'calc((100vw - 1280px) / 2)',
          margin: '0 auto'
        } : {};
        var finishedText = !tiles || tiles.length === 0 ?
        /*#__PURE__*/
        // || (target.useSnomLinkId && allDone)
        _react["default"].createElement("div", {
          className: "".concat(_NestedFlipTiles["default"].finishedText, " ").concat(this.state.finishedTextVisible ? _NestedFlipTiles["default"].visible : ''),
          dangerouslySetInnerHTML: {
            __html: "<div>".concat((0, _DrupalTilesStrings.getString)('FINISHED_TEXT'), "<br />").concat((0, _DrupalTilesStrings.getString)('FINISHED_TEXT2B', [decodeURIComponent(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOM_REDIRECT_URL))]), "</div>")
          }
        }) : null;

        var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

        var spocContent = _KESI2Helper["default"].getContentById(id); // TODO: levels in style here is a hack


        var _content = /*#__PURE__*/_react["default"].createElement("div", {
          id: this.getFrameElementId(this.props.isInBackground),
          style: (0, _assign["default"])({}, this.getBasicStyle(level === LEVELS.ROOT ? LEVELS.SPOC : level, this.props.isInBackground), {
            paddingTop: showingTiles ? '40px' : 0
          }, paddingObj),
          className: _config["default"].showScrollBar ? null : _NestedFlipTiles["default"].hideScrollbar
        }, this.renderOuterShield(id, spocContent), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            margin: 'auto',
            maxWidth: "".concat(_cssConstants["default"].appMaxWidth ? _cssConstants["default"].appMaxWidth + 1 : 1025, "px"),
            // TODO -> make this 28vh target dependant when there is a newsblock
            height: "calc(100vh - ".concat(_cssConstants["default"].navBarHeight, "px)"),
            backgroundColor: _cssConstants["default"].colors.tileBackgroundColor
          }
        }, this.renderShield(id, spocContent), goUpButton, finishedText || tiles), /*#__PURE__*/_react["default"].createElement("div", null, flippingTile));

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.props.isInBackground ? 'background' : '',
          style: this.props.isInBackground ? this.getBackgroundOverlayStyle() : {
            width: '100%',
            height: '100%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: this.props.isInBackground ? 'scroller' : '',
          style: (0, _assign["default"])({
            width: '100vw',
            height: '100%'
          }, this.props.isInBackground ? {
            overflowY: 'hidden'
          } : {}),
          onScroll: this.onScroll
        }, /*#__PURE__*/_react["default"].createElement("div", null, showingTiles ? this.renderInfoBox(level) : null, showExtraMenu ? this.renderExtraMenu() : null, _content)));
      }

      var tileSize = {
        height: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM,
        width: _DrupalNestedTileSizes.TILE_SIZES.MEDIUM
      };
      var tileForBack = this.renderTile(contentTree, tileSize, false);
      var forcedUIColor;

      var content = _KESI2Helper["default"].getContentById(contentTree.id);

      if (_config["default"].useTileBackgroundColorInTile && content.backgroundColor && tileForBack && tileForBack.backgroundColor) {
        forcedUIColor = tileForBack.backgroundColor;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getFrameElementId(this.props.isInBackground)
      }, /*#__PURE__*/_react["default"].createElement(_DrupalNuggetBack["default"], {
        colorClasses: _TilesColorHelper["default"].getColorFromKey(contentTree.keyword, contentTree.id),
        tile: tileForBack,
        contentId: contentTree.id,
        setCount: this.props.setCount,
        doNotSetHeight: this.props.flipped,
        zoomValue: this.props.zoomValue,
        tileSize: tileSize.height,
        goUpFunc: this.props.goUpFunc,
        showGoUpButton: this.props.showGoUpButton,
        contentPathArray: this.props.contentPathArray,
        setShowFavButton: this.props.setShowFavButton,
        setBackButtonFunc: this.props.setBackButtonFunc,
        doNotRenderFlipping: this.props.doNotRenderFlipping,
        forcedUIColor: forcedUIColor
      }));
    }
  }]);
  return DrupalTiles;
}(_KESI2BasicComponent["default"]);

DrupalTiles.propTypes = {
  setCount: _propTypes["default"].func,
  contentPathArray: _propTypes["default"].array.isRequired,
  isRoot: _propTypes["default"].bool,
  isInBackground: _propTypes["default"].bool,
  renderChildrenForId: _propTypes["default"].string,
  hideTileForId: _propTypes["default"].string,
  showOnlyTileWithId: _propTypes["default"].string,
  // overwrites hideTileForId
  flipped: _propTypes["default"].bool.isRequired,
  onComponentDidUpdate: _propTypes["default"].func,
  animated: _propTypes["default"].bool,
  zoomValue: _propTypes["default"].number.isRequired,
  colCount: _propTypes["default"].number.isRequired,
  goUpFunc: _propTypes["default"].func.isRequired,
  showGoUpButton: _propTypes["default"].bool.isRequired,
  showGoUpButtonOnBack: _propTypes["default"].bool.isRequired,
  navigationAllowed: _propTypes["default"].bool.isRequired,
  isHidden: _propTypes["default"].bool,
  renderFront: _propTypes["default"].bool,
  scrollFrameId: _propTypes["default"].string,
  onOpenTile: _propTypes["default"].func,
  rootScrollTop: _propTypes["default"].number,
  showBackground: _propTypes["default"].bool,
  setShowFavButton: _propTypes["default"].func,
  doNotRenderFlipping: _propTypes["default"].bool,
  disableTransitionsInFlippingTile: _propTypes["default"].any,
  // change this value to force re-render
  setBackButtonFunc: _propTypes["default"].func,
  forcedHeight: _propTypes["default"].string,
  forcedUIColor: _propTypes["default"].string
};
DrupalTiles.defaultProps = {
  isHidden: false,
  renderChildrenForId: null,
  isRoot: true,
  renderFront: true,
  hideTileForId: null,
  showOnlyTileWithId: null,
  onFlippingDone: function onFlippingDone() {},
  onComponentDidUpdate: function onComponentDidUpdate() {},
  animated: true,
  isInBackground: false,
  scrollFrameId: null,
  rootScrollTop: 0,
  showBackground: false,
  doNotRenderFlipping: false,
  colCount: 3,
  // must be set by parent anyway, this is just a fallback
  forcedHeight: null
};
var _default = DrupalTiles;
exports["default"] = _default;